var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"path-bar"}},[_vm._t("default"),_vm._v(" "),_c('Breadcrumb',{attrs:{"separator":_vm.separator}},_vm._l((_vm.breadcrumb),function(item,index){return _c('BreadcrumbItem',{key:index,attrs:{"to":item.to}},[_vm._v("\n      "+_vm._s(item.title)+"\n    ")])}),1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43c9efff","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/commons/components/PathBar.vue
// module id = null
// module chunks = 